import {
  Component, Input
} from '@angular/core';

import { BaseComponent }     from '@tytapp/common';
import { ApiPoll, PollsApi } from '@tytapp/api';

@Component({
  selector: 'tyt-featured-card-poll',
  templateUrl: './featured-card-poll.component.html',
  styleUrls: ['./featured-card-poll.component.scss']
})  
export class FeaturedCardPollComponent extends BaseComponent {

  @Input()
  FeaturedQuestion = 0;

  @Input()
  poll: ApiPoll;

  selectedChoice;

  constructor(private _PollsApi: PollsApi) {
    super();
  }

  async vote() {
    await this._PollsApi.pollVote(this.poll.id, {
      poll_question_id: this.poll.questions[0].id,
      choice_ids: `${this.poll.questions[0].choices[this.selectedChoice].id}`
    }).toPromise();
    
  }
}
